$( '.media-carousel' ).each( function() {
	const $this = $( this );

	let swiper = new Swiper( this, {
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		grabCursor: true,
		slidesPerView: 1,
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
		},
		spaceBetween: 20,
	} );
} );

$( '.floor-carousel' ).each( function() {
	const $this = $( this );

	let swiper = new Swiper( this, {
		grabCursor: false,
		slidesPerView: 1,
		spaceBetween: 0,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		loop: false,
		allowTouchMove: false,
		navigation: false,
		pagination: {
			el: $this.parents( '.floor-carousel-container' ).find( '.floor-bullets' )[ 0 ],
			clickable: true,
			renderBullet: function( index, className ) {
				const title = $this.parents( '.floor-carousel-container' ).find( '.floor-slide' ).eq( index ).attr( 'data-title' );

				return '<span class="rounded-none floor-bullet invisible-link w-full py-1 bg-transparent ' + className + '">' + title + '</span>';
			},
		},
	} );

	$this.parents( '.floor-carousel-container' ).find( '.floor-bullet' ).on( 'click', function() {
		toggleFloorOptions();
	} );
} );

$( '.floor-toggle-button' ).on( 'click', function() {
	toggleFloorOptions();
} );

function toggleFloorOptions() {
	$( '.floor-toggle-options' ).slideToggle( 300 );
	$( '.floor-toggle-options-container' ).toggleClass( 'bg-light-beige-2' );
	$( '.floor-toggle-button .icon' ).toggleClass( 'rotate-45' );
}

$( '.version-carousel' ).each( function() {
	const $this = $( this );

	let swiper = new Swiper( this, {
		navigation: {
			nextEl: $this.parents( '.version-carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.version-carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		loop: true,
		grabCursor: true,
		slidesPerView: 1,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: $this.parents( '.version-carousel-container' ).find( '.version-bullets' )[ 0 ],
			clickable: true,
			renderBullet: function( index, className ) {
				const title = $this.parents( '.version-carousel-container' ).find( '.version-slide' ).eq( index ).attr( 'data-title' );

				return '<span class="version-bullet transition-all bg-white text-dark-red rounded-[4px] px-2 py-0.5 invisible-link paragraph-3 ' + className + '">' + title + '</span>';
			},
		},
	} );
} );
